import { createUseStyles } from 'react-jss'

export const useStyles = createUseStyles(theme => ({
  title: {
    fontSize: 40,
    fontFamily: 'GothamRounded',
    lineHeight: 1,
    fontWeight: 450,
    letterSpacing: 'normal',
    textAlign: 'center',
    margin: [20, 0],
    [theme.media.smallMobile]: {
      margin: [10, 20],
      fontSize: 32
    }
  },

  subTitle: {
    fontSize: 18,
    fontFamily: 'GTWalsheim',
    lineHeight: 1,
    fontWeight: 500,
    letterSpacing: 'normal',
    textAlign: 'center',
    marginTop: 0,
    [theme.media.smallMobile]: {
      fontSize: 16,
      margin: [0, 20],
      lineHeight: '18px'
    }
  },

  loadingContainer: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    padding: 50,
    height: 200
  },

  loadingContentContainer: {
    animation: '$fadeInOpacity 2s linear'
  },

  '@keyframes fadeInOpacity': {
    '0%': {
      opacity: 0
    },
    '100%': {
      opacity: 1
    }
  }
}))
